module.exports = __webpack_public_path__ + "img/ilus-web-03.0b81527c.svg";